import { create, get } from "./apiService";

export interface PayLinksPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

/** Document shape from GET /api/v2/business/:id/wallet/paylinks */
export interface ApiPayLink {
  _id: string;
  businessId?: string;
  createdBy?: string;
  amount?: { $numberDecimal: string } | number | string;
  currency?: string;
  description?: string;
  reference?: string;
  status?: string;
  paymentMethod?: string;
  recipientName?: string;
  recipientSurname?: string;
  cryptoAsset?: string;
  walletAddress?: string | null;
  payLinkId?: string;
  payLinkUrl?: string;
  expiresAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ListPayLinksApiData {
  payLinks: ApiPayLink[];
  pagination: PayLinksPagination;
}

export interface CreatePayLinkBody {
  amount: number;
  currency: string;
  description: string;
  reference: string;
  paymentMethod: string;
  recipientName: string;
  recipientSurname: string;
  cryptoAsset: string;
}

export function extractCreatedPayLinkFromApiResponse(axiosResponse: {
  data?: unknown;
}): ApiPayLink | null {
  const envelope = axiosResponse.data as
    | { data?: { payLinks?: ApiPayLink[] } & Partial<ApiPayLink> }
    | undefined;
  const block = envelope?.data;
  if (!block) {
    return null;
  }
  const list = block.payLinks;
  if (Array.isArray(list) && list.length > 0) {
    return list[0] ?? null;
  }
  if (
    typeof (block as ApiPayLink)._id === "string" ||
    typeof (block as ApiPayLink).payLinkId === "string"
  ) {
    return block as ApiPayLink;
  }
  return null;
}

export const createPayLink = async (
  businessId: string,
  body: CreatePayLinkBody
) => {
  return create(`/api/v2/business/${businessId}/wallet/paylinks`, body);
};

export const listPayLinks = async (
  businessId: string,
  params: { page?: number; limit?: number } = {}
) => {
  const query = new URLSearchParams();
  if (params.page != null) query.set("page", String(params.page));
  if (params.limit != null) query.set("limit", String(params.limit));
  const qs = query.toString();
  return get(
    `/api/v2/business/${businessId}/wallet/paylinks${qs ? `?${qs}` : ""}`
  );
};
